"use strict";
var Ajaxinate = function (config) {
    var settings = config || {},
        defaultSettings = {
            pagination: ".AjaxinatePagination",
            method: "scroll",
            container: ".AjaxinateLoop",
            offset: 0,
            loadingText: "Cargando más productos...",
            callback: null
        };
    this.settings = Object.assign(defaultSettings, settings),
    this.addScrollListeners = this.addScrollListeners.bind(this),
    this.addClickListener = this.addClickListener.bind(this),
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this),
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this),
    this.destroy = this.destroy.bind(this),
    this.containerElement = document.querySelector(this.settings.container),
    this.paginationElement = document.querySelector(this.settings.pagination),
    this.initialize();
};

Ajaxinate.prototype.initialize = function () {
    if (this.containerElement) {
        var initializers = {
            click: this.addClickListener,
            scroll: this.addScrollListeners
        };
        initializers[this.settings.method]();
    }
};

Ajaxinate.prototype.addScrollListeners = function () {
    if (this.paginationElement) {
        document.addEventListener("scroll", this.checkIfPaginationInView);
        window.addEventListener("resize", this.checkIfPaginationInView);
        window.addEventListener("orientationchange", this.checkIfPaginationInView);
    }
};

Ajaxinate.prototype.addClickListener = function () {
    if (this.paginationElement) {
        this.nextPageLinkElement = this.paginationElement.querySelector("a");
        this.clickActive = true;
        if (this.nextPageLinkElement !== null) {
            this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
        }
    }
};

Ajaxinate.prototype.stopMultipleClicks = function (event) {
    event.preventDefault();
    if (this.clickActive) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.clickActive = false;
        this.loadMore();
    }
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
    var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
        bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    if (top <= window.innerHeight && bottom >= 0) {
        this.nextPageLinkElement = this.paginationElement.querySelector("a");
        this.removeScrollListener();
        if (this.nextPageLinkElement) {
            this.nextPageLinkElement.innerHTML = this.settings.loadingText;
            this.nextPageUrl = this.nextPageLinkElement.href;
            this.loadMore();
        }
    }
};

Ajaxinate.prototype.loadMore = function () {
    var _this = this;
    var request = new XMLHttpRequest();
    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            var newContainer = request.responseXML.querySelectorAll(_this.settings.container)[0];
            var newPagination = request.responseXML.querySelectorAll(_this.settings.pagination)[0];
            // newContainer.querySelectorAll('product-card').forEach(function (ele) {
            //     ele.setAttribute('style', 'opacity: 1; transform: translateY(0px);');
            // });
            _this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
            _this.paginationElement.innerHTML = newPagination.innerHTML;
            _this.settings.callback && typeof _this.settings.callback === "function" && _this.settings.callback(request.responseXML);
            // Load images asynchronously
            var images = _this.containerElement.querySelectorAll('img');
            images.forEach(function (img) {
                if (!img.complete) {
                    img.addEventListener('load', function () {
                        // Once loaded, remove the loading style
                        img.removeAttribute('style');
                    });
                } else {
                    img.removeAttribute('style');
                }
            });
            _this.initialize();
        }
    };
    request.open("GET", this.nextPageUrl);
    request.responseType = "document";
    request.send();
};

Ajaxinate.prototype.removeClickListener = function () {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function () {
    document.removeEventListener("scroll", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
    var destroyers = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener
    };
    destroyers[this.settings.method]();
    return this;
};
